import type { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { SeverityLevel } from "@microsoft/applicationinsights-web";

export function trackUnknownError(
  applicationInsights: ApplicationInsights,
  error: unknown,
  message: string = "Error of unknown type was thrown",
) {
  if (error instanceof Error) {
    applicationInsights.trackException({
      exception: error,
      severityLevel: SeverityLevel.Error,
      properties: { errorMessage: message },
    });
  } else {
    applicationInsights.trackTrace({ message: message, severityLevel: SeverityLevel.Error });
  }
}
